import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog } from '@nx-smartmonkey/ui';

import Button from '../react-components/Button';
import Text from '../react-components/Text';

type ConfirmDeleteDialogProps<T> = {
  open: boolean;
  onCloseDialog: () => any;
  data: T[];
  handleDelete: () => any;
  typeData: `plans` | `services` | `routes` | `clients` | `vehicles` | `geo_fences` | `supervisors`;
  loading?: boolean;
};

export const ConfirmDeleteDialog = <T,>({
  open,
  data,
  typeData,
  loading,
  onCloseDialog,
  handleDelete,
}: ConfirmDeleteDialogProps<T>) => (
  <RoutalDialog
    open={open}
    onCloseDialog={() => {
      if (!loading) onCloseDialog();
    }}
    titleContent={<Text variant="h6" intlId={`${typeData}.delete_dialog.title`} />}
    footerContent={
      <Grid container justifyContent="flex-end">
        <Button
          id="delete_dialog.confirm"
          variant="flat"
          onClick={() => onCloseDialog()}
          intlId={`${typeData}.delete_dialog.cancel`}
          disabled={loading}
        />
        <HSpacer small />
        <Button
          id="delete_dialog.delete"
          disabled={loading}
          onClick={() => {
            handleDelete();
          }}
          intlId={`${typeData}.delete_dialog.confirm`}
        />
      </Grid>
    }
  >
    <Text intlId={`${typeData}.delete_dialog.content`} intlValues={{ data: Array.isArray(data) ? data.length : `1` }} />
  </RoutalDialog>
);
